import claims from './claims';

export default {
  ...claims,
  insurance: 'Insurance',
  insuranceData: 'Insurance Data',
};